module.exports = __webpack_public_path__ + "static/icons/crear_cuenta.88346dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconsv6/crear_cuenta.svg
// module id = rR/c
// module chunks = 1